import React, { useState, useEffect } from 'react';
import { app } from '../BD/Config';
import { setDoc, doc, serverTimestamp, query, collection, where, getDocs } from 'firebase/firestore';
import { db } from '../auth/UsersConfig/Authfirebase';
import TakePicture from '../Sup_Components/TakePicture';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { nanoid } from 'nanoid';
import '../StyleBase/TakePicture.css'; // Importa el archivo CSS
import Select from 'react-select';
import { ConvertObjToArrayList } from '../Tools/Converts';
import ProgressLoad from '../Tools/ProgressLoad';
import './Products.css';

const Products = () => {
  const [id, setId] = useState('');
  const quillFormats = ['header', 'font', 'size', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image', 'video'];
  const quillModules = {
    toolbar: [
      [{ header: '1' }, { header: '2' }, { header: '3' }, { header: '4' }, { header: '5' }, { header: '6' }, { font: [] }],
      [{ size: [] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['link', 'image', 'video'], ['clean']
    ]
  };

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [comparePrice, setComparePrice] = useState('');
  const [quantity, setQuantity] = useState(''); // Nuevo estado para la cantidad de artículos
  const [ProgrLoading, setProgrLoading] = useState(false);
  const [Categoria, setCategoria] = useState([]);
  const [selectedCategoria, setSelectedCategoria] = useState(null);
  const [images, setImages] = useState({
    "1": { Url: "", UrlMin: "" },
    "2": { Url: "", UrlMin: "" },
    "3": { Url: "", UrlMin: "" },
    "4": { Url: "", UrlMin: "" },
    "5": { Url: "", UrlMin: "" },
    "6": { Url: "", UrlMin: "" }
  });
  const [error, setError] = useState('');

  function handleChange(newValue) {
    setDescription(newValue);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    const errors = [];
    if (!name) errors.push('Nombre');
    if (!description) errors.push('Descripción');
    if (!price) errors.push('Precio');
    if (!comparePrice) errors.push('%Descuento');
    if (!quantity) errors.push('Cantidad'); // Validación para la cantidad de artículos
    if (!selectedCategoria) errors.push('Categoría');
    if (Object.values(images).every(img => !img.Url)) errors.push('Al menos una imagen');

    if (errors.length > 0) {
      setError(`Los siguientes campos son obligatorios: ${errors.join(', ')}`);
      return;
    }

    setProgrLoading(true);
    const NuevoProductos = {
      Activo: true,
      AddRec: serverTimestamp(),
      EndRec: serverTimestamp(),
      nombre: name,
      desc: description,
      Cat: selectedCategoria.value,
      CatName: selectedCategoria.label,
      price: parseFloat(price),
      comparePrice: parseFloat(comparePrice),
      quantity: parseInt(quantity), // Incluir la cantidad de artículos
      Img: images
    };

    const Collect = doc(db, "products", id);
    await setDoc(Collect, NuevoProductos);
    HideLoading();
  };

  const updateImage = (noImg, url, urlMin) => {
    setImages(prevImages => ({
      ...prevImages,
      [noImg]: { Url: url, UrlMin: urlMin }
    }));
  };

  const styles = {
    editor: {
      border: "1px solid black", minHeight: "6em", cursor: "text"
    }
  };

  useEffect(() => {
    const newId = nanoid();
    GetWhereCategoria();
    setId(newId);
  }, []);

  const GetWhereCategoria = async () => {
    try {
      const collectRef = collection(db, "Catalogos");
      const queryRef = query(collectRef, where('Activo', '==', true), where('NoList', '==', 2));
      const snapshot = await getDocs(queryRef);

      let datList = [];
      snapshot.docs.forEach((doc) => {
        datList = ConvertObjToArrayList(doc.data().List);
      });

      setCategoria(datList);

    } catch (error) {
      console.error('Error fetching data:', error);
      setCategoria([]);
    }
  };

  const HideLoading = () => {
    setTimeout(() => { setProgrLoading(false); }, 300);
  };

  const Limpiar = () => {
    setName('');
    setDescription('');
    setPrice(0);
    setComparePrice(0);
    setQuantity(0); // Limpiar el campo de cantidad de artículos
    setSelectedCategoria(null);
    setError('');
  };

  const closeError = () => {
    setError('');
  };

  return (
    <div>
      <button onClick={Limpiar} className="btn btn-primary">Limpiar</button>
      <h2>Productos</h2>
      {error && (
        <div className="alert alert-danger error-message">
          {error}
          <button type="button" className="close" onClick={closeError}>
            &times;
          </button>
        </div>
      )}
      <form className="my-form" onSubmit={handleSubmit}>
        <div className="form-group image-container">
          <div className="image-item">
            <TakePicture DocID={id} NoImg="1" detalle={images["1"]} key={id + "-1"} onUpload={updateImage} />
          </div>
          <div className="image-item">
            <TakePicture DocID={id} NoImg="2" detalle={images["2"]} key={id + "-2"} onUpload={updateImage} />
          </div>
          <div className="image-item">
            <TakePicture DocID={id} NoImg="3" detalle={images["3"]} key={id + "-3"} onUpload={updateImage} />
          </div>
          <div className="image-item">
            <TakePicture DocID={id} NoImg="4" detalle={images["4"]} key={id + "-4"} onUpload={updateImage} />
          </div>
          <div className="image-item">
            <TakePicture DocID={id} NoImg="5" detalle={images["5"]} key={id + "-5"} onUpload={updateImage} />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="nameInput">Nombre:</label>
          <input
            type="text" className="form-control" id="nameInput" value={name} onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="descriptionInput">Descripción:</label>
          <div className="my-editor">
            <ReactQuill
              value={description}
              onChange={handleChange}
              modules={quillModules}
              formats={quillFormats}
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="priceInput">Precio:</label>
          <input
            type="number"
            step="0.01"
            className="form-control"
            id="priceInput"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="comparePriceInput">%Descuento:</label>
          <input
            type="number"
            step="0.01"
            className="form-control"
            id="comparePriceInput"
            value={comparePrice}
            onChange={(e) => setComparePrice(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="quantityInput">Cantidad:</label>
          <input
            type="number"
            className="form-control"
            id="quantityInput"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
        </div>

        <label>Categoria:</label>
        <Select options={Categoria} placeholder="Categoria" className='LtEstados' value={selectedCategoria} onChange={setSelectedCategoria} />
        <button type="submit" className="btn btn-primary">Guardar</button>
      </form>
      {ProgrLoading === true ? <ProgressLoad /> : ""}
    </div>
  );
};

export default Products;
